import type { AppLanguage } from "~/i18n/languagePreference";

import i18n from "~/i18n/i18n";
import { DEFAULT_LANGUAGE, normalizeLanguage } from "~/i18n/languagePreference";

export const BCP47_TAG_BY_LANGUAGE: Record<AppLanguage, string> = {
	en: "en-US",
	es: "es-MX"
};

export const localeTagFor = (language: AppLanguage): string =>
	BCP47_TAG_BY_LANGUAGE[language] ?? BCP47_TAG_BY_LANGUAGE[DEFAULT_LANGUAGE];

export const activeLanguage = (): AppLanguage => normalizeLanguage(i18n.resolvedLanguage ?? i18n.language);

const activeLocaleTag = (): string => localeTagFor(activeLanguage());

export default activeLocaleTag;
